<template>
  <div class="official-account">
    <el-popover
        placement="bottom"
        popper-class="official-account-popover"
        trigger="hover">
      <div class="official-account-qrcode">
        <div class="qrcode"><img :src="this.baseUrl+'global/official-account.jpg'" class="qrcode-pic"/></div>
      </div>
      <div class="official-account-text" slot="reference">
        <i class="official-account-prefix"/>
        关注公众号
      </div>
    </el-popover>
  </div>
</template>

<script>
export default {
  name: 'OfficialAccount',
  data() {
    return {
      baseUrl: this.$store.state.baseUrl,
    }
  },
}
</script>

<style lang="less">
.official-account {
  &-popover {
    padding: 0;
    min-width: unset;
    border: none;
  }

  &-text {
    font-size: 14px;
    color: #3D3F44;
    margin-right: 20px;
    cursor: pointer;
    display: flex;
    align-items: center;
  }

  &-prefix {
    content: url("./ic_scan.svg");
    margin-right: 5px;
    position: relative;
  }

  &-qrcode {
    text-align: center;
    background: #FFFFFF;
    box-shadow: 0 0 8px rgba(135, 169, 214, 0.25);
    border-radius: 4px;
    mix-blend-mode: normal;
    color: rgba(117, 127, 143, 1);
    font-size: 14px;
    display: flex;


    .qrcode {
      padding: 8px 4px 4px 4px;

      &-pic {
        width: 129px;
        height: 129px;
      }
    }
  }
}

</style>
>
